import PublicRoute from '../components/RouteVisibility/PublicRoute/PublicRoute'
import LoginPage from '../pages/Login/LoginPage'
import React from 'react'

export const LOGIN_PATH = '/login',
	REGISTER_PATH = '/register',
	RECOVERY_PATH = '/recovery'

export const LOGIN_ROUTES = [
	{
		path: LOGIN_PATH,
		element: <PublicRoute />,
		children: [
			{
				path: '',
				element: <LoginPage />,
			},
		],
	},
	{
		path: REGISTER_PATH,
		element: <PublicRoute />,
		children: [
			{
				path: '',
				element: <LoginPage />,
			},
		],
	},
	{
		path: RECOVERY_PATH,
		element: <PublicRoute />,
		children: [
			{
				path: '',
				element: <LoginPage />,
			},
		],
	},
]
